import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import PortalModal from "../../Portals";
import ErrorOutlinedIcon from "@material-ui/icons/ErrorOutlined";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModal,
  ButtonConfirm,
  ButtonCancel,
  CloseModal,
  TextModal,
  ContentSelect,
  SelectStyles,
  IconGuest,
  useStyles,
} from "./ModalConfirmAction.styled";
import Select from "react-select";
import userIcon from "../../assets/svg/users-icon.svg";
import { Form } from "react-bootstrap";
import { ALL_ROLES_BY_LEVEL, USERS_IN_ROLE2 } from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";

const ModalConfirmAction = ({
  title,
  open,
  setOpen,
  fn,
  activeCloneCheckbox = false,
  setNewOwner,
  newOwner,
  itsForm,
}) => {
  const classes = useStyles();
  const rSelectedUsers = useRef();
  const [dataUsers, setDataUsers] = useState();
  const [allRolesByLevel, setRolesByLevel] = useState([]);
  const [otherOwnerChecked, setOtherOwnerChecked] = useState(false);
  const [user] = useState(getStateLoginComplete());
  const [word] = useState(itsForm ? "form" : "survey");

  const [runQueryRolesByLevel] = useLazyQuery(ALL_ROLES_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllRolesByLevel = data?.rolesByUserProfile.map((element) => {
        return {
          value: element?.roleId,
          label: element?.friendlyDescription,
          roleLevel: element?.roleLevel,
        };
      });
      setRolesByLevel(resultOfAllRolesByLevel);
    },
  });

  const [runQueryUsersInRole2] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersInRole2 = data.userListAdvancedSearch.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userTpId,
          ccmsuser: element?.userCcms,
        };
      });
      setDataUsers(usersInRole2);
    },
  });

  let handleQueryOfUSers = (allRolesByUser) => {
    let rolesId = allRolesByUser.map((element) => {
      return element.value;
    });
    if (rolesId && rolesId.length > 0) {
      runQueryUsersInRole2({
        variables: { rolesId: rolesId },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  let handleQueryOfRoles = (role_id) => {
    if (role_id) {
      runQueryRolesByLevel({
        variables: { roleId: role_id },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  useEffect(() => {
    handleQueryOfUSers(allRolesByLevel);
  }, [allRolesByLevel]);

  useEffect(() => {
    handleQueryOfRoles(user.roleId);
  }, [user.roleId]);

  useEffect(() => {
    cleanSelection();
  }, [otherOwnerChecked]);

  let cleanSelection = () => {
    if (otherOwnerChecked) {
      setNewOwner();
    }
  };

  let handleOtherOwner = (e) => {
    setOtherOwnerChecked(e.target.checked);
  };
  let handleChangeSelectOwner = (item) => {
    setNewOwner(item.ccmsuser);
  };

  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal activeCloneCheckbox={activeCloneCheckbox}>
          <div style={{ textAlign: "center" }}>
            <ErrorOutlinedIcon />
            <p>{title}</p>
          </div>

          {activeCloneCheckbox && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "0.75rem" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    styles={classes.checkboxStyle}
                    checked={otherOwnerChecked}
                    onChange={(e) => handleOtherOwner(e)}
                    name="other-owner-check"
                  />
                }
                label={`Do you want to change ownership of the cloned ${word}?`}
              />
            </div>
          )}
          {otherOwnerChecked && (
            <ContentSelect>
              <Form.Label>
                <IconGuest src={userIcon}></IconGuest> Select new survey's owner
              </Form.Label>
              <Select
                placeholder="Type user"
                ref={rSelectedUsers}
                options={dataUsers}
                styles={SelectStyles}
                onChange={handleChangeSelectOwner}
              />
            </ContentSelect>
          )}
        </TextModal>
        <div style={{ display: "flex", justifyContent: "center", gap: "1rem", padding: "1rem 0" }}>
          <ButtonConfirm
            disabled={otherOwnerChecked && !newOwner}
            onClick={() => fn(open)}
          >
            {activeCloneCheckbox ? "OK" : "Yes"}
          </ButtonConfirm>
          <ButtonCancel onClick={() => setOpen(null)}>
            {activeCloneCheckbox ? "Cancel" : "No"}
          </ButtonCancel>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalConfirmAction;
